export enum NotificationTypeEnum {
  sendPush = 'SEND_PUSH',
  sendSMS = 'SEND_SMS',
  sendWhatsApp = 'SEND_WHATSAPP',
  sendEmail = 'SEND_EMAIL',
}
